import { useMelwaysInfo, useMelwaysLink } from '@seek/melways-react';
import { type Language, siteConfig } from '@seek/melways-sites';
import { useLocation } from 'react-router';

interface ReturnType {
  languageSwitcher?: Record<
    Language,
    {
      url: string;
    }
  >;
  onLanguageSwitch?: (language: Language) => void;
}

export const useLanguageSwitcher = (): ReturnType => {
  const { site, pathWithoutLanguage } = useMelwaysInfo();
  const { search } = useLocation();
  const localise = useMelwaysLink();

  const { languages } = siteConfig[site];
  const isMultiLangs = languages.length > 1;

  if (!isMultiLangs) {
    return {};
  }

  const languageSwitcher = languages.reduce(
    (acc, lang) => ({
      ...acc,
      [lang]: {
        url: localise({
          path: `${pathWithoutLanguage}${search}`,
          language: lang,
        }),
      },
    }),
    {} as Record<Language, { url: string }>,
  );

  return {
    languageSwitcher,
    onLanguageSwitch: (language: Language) => {
      window.location.href = languageSwitcher[language].url;
    },
  };
};
